import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Link from '@material-ui/core/Link';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Popover from '@material-ui/core/Popover';
import Modal from '@material-ui/core/Modal';
import {saveId} from "../../store/action/setting.action";
import {message, Button as Button_antd, Tooltip} from 'antd';
import {SaveOutlined, UndoOutlined, CopyOutlined} from "@ant-design/icons";


export default function integrationForm(props){

    return(
        <div style={{marginTop:"35px"}}>
            {/*<Popover*/}
            {/*    id="popup_copy"*/}
            {/*    open={props.store.is_show_popup_copy}*/}
            {/*    anchorEl={props.store.anchor_popup}                */}
            {/*    anchorOrigin={{*/}
            {/*        vertical: 'top',*/}
            {/*        horizontal: 'left',*/}
            {/*        }}*/}
            {/*        transformOrigin={{*/}
            {/*        vertical: 'bottom',*/}
            {/*        horizontal: 'right',*/}
            {/*        }}*/}
            {/*>*/}
            {/*    <div style={{padding:"10px"}}>{props.store.copy_ready_text}</div>*/}
            {/*</Popover>*/}

            <Grid container justify="center" spacing={0} style={{marginTop:"35px"}}>
                <Grid item xs={10} style={{display:"flex", justifyContent:"center", paddingRight: "5px"}}>
                    <TextField
                        id="token_text"
                        label={props.store.token_field_descr_text + props.service}
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={props.token}
                        // onChange={(obj)=>{props.action.changeToken(obj.currentTarget.value)}}
                        InputProps={{
                            endAdornment:
                                <CopyToClipboard
                                    text={props.token}
                                    onCopy={() => message.success('Скопировано')}
                                >
                                    <Button_antd style={{width: '20px'}}   type="link" onClick={()=>{props.action.saveId(props.store.id_salon, props.store.app_id)}}>
                                        <CopyOutlined style={{fontSize: '18px'}} />
                                    </Button_antd>
                                </CopyToClipboard>,
                            }}
                    />
                </Grid>
                            {/*    <Grid item xs={2}*/}
            {/*        style={{display:"flex", justifyContent:"right"}}>*/}
            {/*        <FormControlLabel*/}
            {/*            control={*/}
            {/*                    <Switch*/}
            {/*                        disabled={*/}
            {/*                            !(*/}
            {/*                                props.store.login_field_saved!=="" &&*/}
            {/*                                props.store.token_saved!=="" &&*/}
            {/*                                props.store.id_salon_saved!=="" &&*/}
            {/*                                props.store.is_token_saved &&*/}
            {/*                                props.store.is_toggle_integration_enable &&*/}
            {/*                                props.store.is_login_saved &&*/}
            {/*                                props.store.is_id_salon_saved*/}
            {/*                            )}*/}
            {/*                        checked={props.store.is_integration}*/}
            {/*                        onChange={ ()=>{props.action.changeIntegration(!props.store.is_integration, props.store.app_id)} }*/}
            {/*                        value="checkedB"*/}
            {/*                        color="primary"*/}
            {/*                        size="medium"*/}
            {/*                    />*/}
            {/*            }*/}
            {/*            label={props.store.toggle_integration_text}*/}
            {/*        />*/}
            {/*    </Grid>*/}
                {/*<Grid item xs={6} style={{paddingLeft: "5px"}}>*/}
                {/*    <TextField spacing={0}*/}
                {/*        id="url_text"*/}
                {/*        fullWidth*/}
                {/*        variant="outlined"*/}
                {/*        size="small"*/}
                {/*        value={props.store.login_field}*/}
                {/*        label={props.store.login_field_descr_text}*/}
                {/*        onChange={(obj)=>{props.action.changeInputLogin(obj.currentTarget.value)}}*/}
                {/*        InputProps={{*/}
                {/*            endAdornment: props.store.is_login_saved? null: <GroupBtnLogin {...props} />,*/}
                {/*            }}*/}
                {/*    />*/}
                {/*</Grid>*/}
            </Grid>
            <Grid container spacing={0} style={{marginTop:"35px"}}>
                <Grid item xs={1} />
                <Grid item xs={7} style={{paddingRight: "5px"}}>
                    <TextField spacing={0}
                        id="url_text"
                        fullWidth
                        variant="outlined"
                        size="small"
                        value={props.store.id_salon}
                        label={'API-ключ Bnovo'}
                        onChange={(obj)=>{props.action.changeIdSalon(obj.currentTarget.value)}}
                        InputProps={{
                            endAdornment: props.store.is_id_salon_saved? null: <GroupBtnID {...props} />,
                            }}
                    />
                </Grid>
                <Grid item xs={1} />
                <Grid item xs={2}
                    style={{display:"flex", justifyContent:"right"}}>
                    <FormControlLabel
                        control={
                                <Switch
                                    disabled={
                                        !(
                                            // props.store.login_field_saved!=="" &&
                                            // props.store.token_saved!=="" &&
                                            props.store.id_salon_saved!=="" &&
                                            // props.store.is_token_saved &&
                                            props.store.is_toggle_integration_enable &&
                                            // props.store.is_login_saved &&
                                            props.store.is_id_salon_saved
                                        )}
                                    checked={props.store.is_integration}
                                    onChange={ ()=>{props.action.changeIntegration(!props.store.is_integration, props.store.app_id)} }
                                    value="checkedB"
                                    color="primary"
                                    size="medium"
                                />
                        }
                        label={props.store.toggle_integration_text}
                    />
                </Grid>
            </Grid>
        </div>
    )
}

function GroupBtnToken(props){
    return(
        <ButtonGroup>
            <Button 
                color="primary" 
                size="medium" 
                style={{width:"110px"}} 
                variant="text" 
                onClick={props.action.cancelToken}>
                    {props.store.token_cancel_btn_text}
            </Button>

            <Button 
                color="primary" 
                size="medium" 
                style={{width:"140px"}} 
                variant="text" 
                onClick={()=>{props.action.saveToken(props.store.token, props.store.app_id)}}>
                    {props.store.token_save_btn_text}
            </Button>
        </ButtonGroup>
    )
}

function GroupBtnLogin(props){
    return(
        <ButtonGroup>
            <Button 
                color="primary" 
                size="medium" 
                style={{width:"110px"}} 
                variant="text" 
                onClick={props.action.cancelLogin}>
                    {props.store.token_cancel_btn_text}
            </Button>

            <Button 
                color="primary" 
                size="medium" 
                style={{width:"140px"}} 
                variant="text"
                onClick={()=>{props.action.saveLogin(props.store.login_field, props.store.app_id)}}>
                    {props.store.token_save_btn_text}
            </Button>
        </ButtonGroup>
    )
}

function GroupBtnID(props){
    return(
        <ButtonGroup>
            {/*<Button*/}
            {/*    color="primary"*/}
            {/*    size="medium"*/}
            {/*    style={{width:"110px"}}*/}
            {/*    variant="text"*/}
            {/*    onClick={props.action.cancelID}>*/}
            {/*        /!*{props.store.token_cancel_btn_text}*!/*/}
            {/*        <UndoOutlined />*/}
            {/*</Button>*/}
            <Tooltip title={'Отменить'}>
                <Button_antd style={{width: '20px'}} type="link" onClick={props.action.cancelID}>
                    <UndoOutlined style={{fontSize: '18px'}} />
                </Button_antd>
            </Tooltip>

            <Tooltip title={'Сохранить'}>
                <Button_antd style={{width: '20px'}}   type="link" onClick={()=>{props.action.saveId(props.store.id_salon, props.store.app_id)}}>
                    <SaveOutlined style={{fontSize: '18px'}} />
                </Button_antd>
            </Tooltip>

            {/*<Button*/}
            {/*    color="primary"*/}
            {/*    size="medium"*/}
            {/*    style={{width:"140px"}}*/}
            {/*    variant="text"*/}
            {/*    onClick={()=>{props.action.saveId(props.store.id_salon, props.store.app_id)}}>*/}
            {/*        /!*{props.store.token_save_btn_text}*!/*/}
            {/*        <SaveOutlined />*/}
            {/*</Button>*/}
        </ButtonGroup>
    )
}